import _                 from 'underscore';
import React, { FC }     from 'react';
import { Link }          from 'react-router-dom';
import { Uuid }          from '../../../types/aliases';
import { RouterUtility } from '../../../util';

interface UserLinkProps {
	accountId: Uuid,
	organizationId: Uuid,
	projectId?: Uuid,
	
	[ additionalProps: string ]: any
}

const defaultProps: UserLinkProps = {
	accountId:      null,
	organizationId: null,
	projectId:      null,
}

const UserLink: FC<UserLinkProps> = ( props ) => {
	
	let routePath = _.isNull( props.projectId ) ? 'USERS.PROFILE' : 'PROJECT.USERS';
	
	return (
		
		<Link to={ RouterUtility.getRoute( routePath, {
			accountId:      props.accountId,
			organizationId: props.organizationId,
			projectId:      props.projectId,
		} ) }>{ props.children }</Link>
	);
};

UserLink.defaultProps = defaultProps;

export { UserLink }
